var map = {
	"./paint-brush-active.svg": 46620,
	"./paint-brush.svg": 48385,
	"./paint-circle.svg": 81331,
	"./paint-clear-active.svg": 39925,
	"./paint-clear-gray.svg": 29742,
	"./paint-clear.svg": 40193,
	"./paint-down.svg": 40031,
	"./paint-eraser-active.svg": 69598,
	"./paint-eraser-gray.svg": 59045,
	"./paint-eraser.svg": 93519,
	"./paint-muti.svg": 77056,
	"./paint-quit-active.svg": 72129,
	"./paint-quit.svg": 36738,
	"./paint-toggle.svg": 55343,
	"./paint-triangle.svg": 16623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;